<div class="reward-container">
  <app-mobile-header [title]="'menu.rewards'" [isShowBackButton]="false"></app-mobile-header>
  <span class="history-btn" *ngIf="rewardSectionType === rewardSectionTypes.MyVoucher" (click)="onClickHistory()">
    {{'label.history' | translate}}
  </span>

  <ng-template [ngIf]="isLoggedIn">
    <div class="reward-header-container">
      <div class="reward-general-header">
        <div class="tab" [ngClass]="{'active': rewardSectionType === rewardSectionTypes.Explore }"
          (click)="onSwitchVoucherType(rewardSectionTypes.Explore)">
          {{'button.explore' | translate}}
        </div>

        <div class="tab" [ngClass]="{'active': rewardSectionType === rewardSectionTypes.MyVoucher }"
          (click)="onSwitchVoucherType(rewardSectionTypes.MyVoucher)">
          {{'label.my.voucher' | translate}}
        </div>

        <div class="tab" [ngClass]="{'active': rewardSectionType === rewardSectionTypes.Membership }"
          (click)="onSwitchVoucherType(rewardSectionTypes.Membership)">
          {{'label.membership' | translate}}
        </div>
      </div>

      <!-- Explore & My Voucher menu -->
      <div class="catg-menu-container"
        *ngIf="categories.length > 0 && rewardSectionType !== rewardSectionTypes.Membership">
        <swiper [slidesPerView]="'auto'" [grabCursor]="true" #swiper class="swiper-menu">
          <ng-template swiperSlide *ngIf="categories">
            <input type="radio" name="category" value="0" id="menu-0" class="radio" (change)="onMenuChange(0);"
              [checked]="categoryId === 0">
            <label class="category not-selectable" for="menu-0">{{ "label.all" | translate }}</label>
          </ng-template>
          <ng-template swiperSlide class="category-wrapper" *ngFor="let category of categories">
            <input type="radio" name="category" value="{{ category.id }}" id="menu-{{ category.id }}" class="radio"
              (change)="onMenuChange(category.id);" [checked]="categoryId === category.id">
            <label class="category not-selectable" for="menu-{{ category.id }}">{{ category.desc
              | translate }}</label>
          </ng-template>
        </swiper>

        <span class="read-more-catg">
          <i class="icon-chevron-down" (click)="onShowMobileMenu()"></i>
        </span>
      </div>

      <form (ngSubmit)="onSearch()" [formGroup]="searchFgroup" class="search-bar">
        <div class="input-outline">
          <i class="icon-search"></i>
          <span class="p-float-label">
            <input class="inputFielsTruncateText" id="searchVoucher" type="text" pInputText formControlName="searchText"
              #searchBar>
            <label for="searchVoucher">{{rewardSectionType === rewardSectionTypes.Membership ?
              ('label.search.membership.hint' | translate) :
              ('label.search.voucher.hint' | translate) }}</label>
          </span>
          <i class="icon-times" *ngIf="searchF.searchText?.value?.length > 0" (click)="onSearch(true)"></i>
        </div>
      </form>
    </div>

    <!-- Explore-->
    <div class="explore-reward-card-listing"
      *ngIf="rewardSectionType === rewardSectionTypes.Explore && (rewards && rewards.length > 0)">
      <div *ngFor="let reward of rewards">
        <app-reward-card [exploreReward]="reward" [isLoggedIn]="isLoggedIn" [storeId]="storeData?.storeId"
          [channelId]="channelId"></app-reward-card>
      </div>
    </div>

    <!-- My Voucher -->
    <div
      *ngIf="rewardSectionType === rewardSectionTypes.MyVoucher && (myRewardList && myRewardList.length > 0 && myRewardCatgList)">
      <div class="myVoucher-reward-card-listing" *ngFor="let myRewardList of myRewardCatgList; let i = index;">
        <div class="merchantDesc-heading" id="storeName-{{ i + 1 }}">{{ myRewardList.merchantDesc | titlecase }}</div>
        <div *ngFor="let myReward of myRewardList.vouchers">
          <app-reward-card [myReward]="myReward" [channelId]="channelId"></app-reward-card>
        </div>
      </div>
    </div>

    <!--Membership-->
    <div *ngIf="rewardSectionType === rewardSectionTypes.Membership && memberDetail.length > 0">
      <app-membership-card [isRewardPage]="true" [membership]="memberDetail"></app-membership-card>
    </div>

    <ng-template [ngIf]="!isOnListLoad && (
      (rewardSectionType === rewardSectionTypes.Explore && rewards && rewards.length <= 0) ||
      (rewardSectionType === rewardSectionTypes.MyVoucher && myRewardList && myRewardList.length <= 0) ||
      (rewardSectionType === rewardSectionTypes.Membership && memberDetail && memberDetail.length <= 0 ))">
      <div class="empty-voucher">
        <img src="assets/generalImage/reward_voucher.svg" alt="mascot"
          *ngIf="(rewardSectionType === rewardSectionTypes.Explore || rewardSectionType === rewardSectionTypes.MyVoucher) && !searchedText" />
        <img src="assets/generalImage/name_card.svg" alt="mascot"
          *ngIf="rewardSectionType === rewardSectionTypes.Membership && !searchedText">
        <img src="assets/generalImage/not_found.svg" alt="mascot" *ngIf="searchedText">
        <!--explore / my voucher-->
        <h1 class="title"
          *ngIf="rewardSectionType === rewardSectionTypes.Explore || rewardSectionType === rewardSectionTypes.MyVoucher">
          {{ 'desc.no.voucher.found' | translate }}</h1>
        <!--desc : explore without search text-->
        <p class="desc" *ngIf="rewardSectionType === rewardSectionTypes.Explore && !searchedText">
          {{'desc.current.no.ongoing.voucher' | translate}}</p>
        <!--desc : my voucher without search text-->
        <p class="desc" *ngIf="rewardSectionType === rewardSectionTypes.MyVoucher && !searchedText">
          {{'desc.no.voucher.found.start.exploring' | translate}}</p>
        <!--desc : explore/ my voucer with search text-->
        <p class="desc"
          *ngIf="(rewardSectionType === rewardSectionTypes.Explore || rewardSectionType === rewardSectionTypes.MyVoucher) && searchedText">
          {{'error.no.voucher.found.try.again' | translate: { searchText: searchedText } }}</p>

        <!--membership-->
        <h1 class="title" *ngIf="rewardSectionType === rewardSectionTypes.Membership">{{'desc.no.membership.found' |
          translate}}</h1>
        <!--membership without search text-->
        <p class="desc" *ngIf="rewardSectionType === rewardSectionTypes.Membership && !searchedText">
          {{'desc.yet.to.join.membership' |
          translate}}</p>
        <!--membership with search text-->
        <p *ngIf="rewardSectionType === rewardSectionTypes.Membership && searchedText">
          {{'error.no.membership.found.try.again' | translate: { searchText: searchedText } }}</p>

        <app-button [textButton]="true" [buttonName]="'button.explore'"
          *ngIf="rewardSectionType === rewardSectionTypes.MyVoucher && !searchedText"
          (click)="onSwitchVoucherType(rewardSectionTypes.Explore)"></app-button>

        <app-button [textButton]="true" [buttonName]="'button.retry'"
          *ngIf="(rewardSectionType === rewardSectionTypes.Explore || rewardSectionType === rewardSectionTypes.MyVoucher || rewardSectionType === rewardSectionTypes.Membership) && searchedText"
          (click)="onSearch(true)"></app-button>
      </div>
    </ng-template>

  </ng-template>

  <ng-template [ngIf]="isOnListLoad">
    <div class="pagination-loader">
      <ng-lottie [options]="{path: '/assets/loader/E-order-loading.json'}"></ng-lottie>
    </div>
  </ng-template>

  <ng-template [ngIf]="!isLoggedIn">
    <app-login-message [isRewardPage]="true" (navigateToLogin)="onLogin()" [pageName]="'reward'"></app-login-message>
  </ng-template>
</div>

<p-dialog position="bottom" [(visible)]="showMobileMenu" [baseZIndex]="999999999999" *ngIf="showMobileMenu"
  [modal]="false" [dismissableMask]="true" [blockScroll]="true"
  styleClass="fullScreen-dialog fullScreenWithBlack-dialog showMobileMenu-dialog">

  <div class="showMobileMenu-container">
    <div class="showMobileMenu-header">
      <h1>{{'label.voucher.categories' | translate}}</h1>
      <i class="icon-times" (click)="showMobileMenu = false"></i>
    </div>
    <hr>

    <div class="showMobileMenu-listing">
      <div class="tab" (click)="onMenuChange(0)" [ngClass]="{'active' : categoryId === 0}">
        {{ "label.all" | translate }}
      </div>
      <div class="tab" *ngFor="let category of categories" (click)="onMenuChange(category.id)"
        [ngClass]="{'active' : categoryId === category.id}">
        {{ category.desc | translate }}
      </div>
    </div>
  </div>
</p-dialog>

<p-dialog position="bottom" *ngIf="showDetail" [(visible)]="showDetail" [modal]="true" [dismissableMask]="true"
  [blockScroll]="true" styleClass="fullScreen-dialog">
  <app-reward-detail [exploreReward]="exploreRewardDetail" [myReward]="myRewardDetail" [currentCart]="cartModel"
    [channelId]="channelId">
  </app-reward-detail>
</p-dialog>

<p-dialog position="bottom" [(visible)]="showShare" [baseZIndex]="9999" *ngIf="showShare" [modal]="false"
  [dismissableMask]="false" [blockScroll]="true" styleClass="fullScreen-dialog fullScreenWithBlack-dialog">
  <app-social-share [url]="shareUrl" [title]="shareStoreName"
    [description]="shareStoreName? ('share.description' | translate: { storeName: shareStoreName }): ''"
    (onClickAction)="showShare = false" class="content"></app-social-share>
</p-dialog>

<p-dialog position="bottom" [(visible)]="showStore" *ngIf="showStore && storeList" [modal]="true"
  [dismissableMask]="true" [blockScroll]="true" styleClass="halfScreen-dialog showStore-dialog">
  <app-nearby-store [storeList]="storeList" [currency]="currency"
    [showRewardDialog]="rewardSectionType === rewardSectionTypes.Explore" [currentCart]="cartModel">
  </app-nearby-store>
</p-dialog>

<p-dialog position="bottom" [(visible)]="showQr" *ngIf="showQr && myRewardQr" [modal]="true" [dismissableMask]="true"
  [blockScroll]="true" (visibleChange)="onReopenVoucherCard($event)" styleClass="showQr-dialog">

  <div class="showQR-content">
    <span class="merchantDesc">{{myRewardQr.merchantDesc}}</span>

    <app-reward-card [myReward]="myRewardQr" [channelId]="channelId" *ngIf="myRewardQr.storeResponseList.length > 0">
    </app-reward-card>

    <span class="label-or" *ngIf="myRewardQr.storeResponseList.length > 0">{{'label.or' | translate}}</span>

    <span class="showText">{{'show.codes.to.cashier.tap.to.zoom' | translate}}</span>

    <app-barcode-qrcode [qrCodeValue]="myRewardQr?.voucherNo" [barCodeValue]="myRewardQr?.voucherNo"
      [isShowDesc]="false" [barCodeWidth]="'180px'" [barCodeHeight]="'60px'" [QrHeight]="'80px'" [QrWidth]="'80px'"
      [qrbarcodegap]="'0px'"></app-barcode-qrcode>
  </div>
</p-dialog>

<p-dialog [position]="dialogPosition" [(visible)]="displayLogin" [baseZIndex]="999999999999" *ngIf="displayLogin"
  [modal]="true" [dismissableMask]="false" [blockScroll]="true"
  [styleClass]="isDialogCenter ? 'centerScreen-dialog' : 'isDisplayWhatsappLogin-dialog'">
  <app-whatsapp-authentication (onClickClose)="displayLogin = false" (onMobileNoLogin)="navigateToLogin()"
    [whatsappEnquiryParam]="whatsappLoginParam" (onShowFail)="onWhatsappFail($event)"
    (onSuccessClose)="onSuccessClose()"></app-whatsapp-authentication>
</p-dialog>